import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@views/Home.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/articles',
    name: 'articles',
    component: () => import('@views/Articles.vue'),
    meta: { title: '文章' }
  },
  {
    path: '/article/:id',
    name: 'article',
    component: () => import('@views/Article.vue'),
    meta: { title: '文章详情' }
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@views/Projects.vue'),
    meta: { title: '作品集' }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/About.vue'),
    meta: { title: '关于' }
  },
  {
    path: '/comment/:path',
    name: 'comment',
    component: () => import('@/views/CommentPage.vue'),
    meta: { title: '文章评论' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0, behavior: 'smooth' }
  }
})

// Update page title on route change
router.afterEach((to) => {
  const title = to.meta.title as string
  document.title = title ? `${title} - PENG. Blog` : 'PENG. Blog'
})

export default router
